<div class="base" *ngIf="authenticated">
  <div class="tools my-2">
    <sl-tooltip *ngIf="loading" content="Calculating routes" i18n-content>
      <sl-spinner class="spinner mr-3" style="--indicator-color: white;"></sl-spinner>
    </sl-tooltip>
    <sl-icon-button *ngIf="showManagement" name="gear" label="Settings" i18n-label
      (click)="handleShowSettings()"></sl-icon-button>
    <sl-dropdown *ngIf="helpUrl != null || supportUrl != null">
      <sl-icon-button slot="trigger" name="question-circle" label="Help" i18n-label></sl-icon-button>
      <sl-menu>
        <sl-menu-item *ngIf="helpUrl != null" (click)="handleShowHelp()" i18n>Show help</sl-menu-item>
        <sl-menu-item *ngIf="supportUrl != null" (click)="handleContactSupport()" i18n>Contact support</sl-menu-item>
      </sl-menu>
    </sl-dropdown>
    <sl-dropdown>
      <sl-avatar [initials]="initials" class="avatar mx-4" style="--size:32px" slot="trigger"></sl-avatar>
      <sl-menu>
        <sl-menu-item (click)="handleShowProfile()" i18n>Your profile</sl-menu-item>
        <sl-menu-item (click)="handleLogout()" i18n>Log out</sl-menu-item>
      </sl-menu>
    </sl-dropdown>

  </div>
</div>